import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../js/h2Api'
import { LIST_DEPLOYMENTS, SEARCH_DEPLOYMENTS } from '../actions/tenantFinder'

const reducers = combineReducers({
  data: h2Api.restReducer(LIST_DEPLOYMENTS),
  search: h2Api.restReducer(SEARCH_DEPLOYMENTS)
})

export default reducers
